import { useState, useCallback } from 'react';
import { useErrorSound } from '#client/utils/hooks/useErrorSound';

export const TOAST_CONSTANTS = {
    TOAST_DURATION: 5000,
    MAX_TOASTS: 5,
    FADE_DURATION: 500, // should be same as the fade duration in Toast.css for fade-out animation
};

let toastIdCounter = 0;

export function useReducedToastQueue() {
    const [toasts, setToasts] = useState([]);
    const playErrorSound = useErrorSound();

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);

    const addToast = useCallback((toast) => {
        toastIdCounter += 1;
        const id = toastIdCounter;
        const newToast = {
            ...toast,
            id,
            createdAt: Date.now(),
            // If disableTimeout is not provided, default to false (timeout enabled)
            disableTimeout: toast.disableTimeout ?? false,
        };

        if (toast.type === 'error' && toast.playSound === true) {
            playErrorSound();
        }

        setToasts((prev) => {
            let next = [newToast, ...prev];

            if (next.length > TOAST_CONSTANTS.MAX_TOASTS) {
                const [oldest] = [...next].sort((a, b) => a.createdAt - b.createdAt);
                next = next.filter((t) => t.id !== oldest.id);
            }

            return next;
        });

        return id;
    }, []);

    const clearToasts = useCallback(() => {
        setToasts([]);
    }, []);

    return {
        toasts,
        addToast,
        removeToast,
        clearToasts,
    };
}
